module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/condition-bg-416a4d283e93c272fb5fbb8ded43c87e.png";